"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanShowRuleInSimpleMode = void 0;
var analyzeRule_1 = require("../analyzeRule");
var getCanShowRuleInSimpleMode = function (data, domainBlangVariables, ruleString) {
    if (ruleString === undefined || ruleString === null) {
        return false;
    }
    // when the rule is empty (add form) we can show it in simple mode
    if (ruleString === '') {
        return true;
    }
    var hasComment = data.hasComment, parsedRule = data.parsedRule, result = data.result;
    // result === false  means that the rule is invalid
    if (result === false || !parsedRule) {
        return false;
    }
    var analyzedRule = (0, analyzeRule_1.analyzeRule)(parsedRule);
    // console.log('analyzedRule ===>', analyzedRule);
    return (analyzedRule &&
        !hasComment &&
        !analyzedRule.containsOR &&
        !analyzedRule.containsLENGTH &&
        !analyzedRule.isUsingCONTAINSWithOccurrences &&
        !analyzedRule.hasArrayValues &&
        !hasCustomerSpecificDetails(analyzedRule.rules) &&
        !hasVariableInValue(analyzedRule.rules) &&
        !hasUnavailableField(analyzedRule.rules, domainBlangVariables));
};
exports.getCanShowRuleInSimpleMode = getCanShowRuleInSimpleMode;
var hasCustomerSpecificDetails = function (rules) {
    return rules.some(function (rule) { return !!rule.sourceData && rule.sourceData.field && rule.sourceData.field.type === 'customerSpecific'; });
};
// Comparing variables  $title EQUALS $body
var hasVariableInValue = function (rules) {
    return rules.some(function (rule) {
        return rule.sourceData &&
            rule.sourceData.value &&
            (0, analyzeRule_1.isParsedRuleValue)(rule.sourceData.value) &&
            rule.sourceData.value.type === 'variable';
    });
};
var hasUnavailableField = function (rules, availableFields) {
    var fieldsUsedInRules = rules.map(function (rule) { return rule.sourceData && rule.sourceData.field && rule.sourceData.field.value; });
    var availableFieldNames = availableFields.map(function (field) { return field.id; });
    return fieldsUsedInRules.some(function (field) { return availableFieldNames.indexOf(field) === -1; });
};
